import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoltLightning, faChartPie, faExclamationTriangle, faHome } from '@fortawesome/free-solid-svg-icons'

const navigation = [
  {
    title: 'Home',
    icon: <FontAwesomeIcon icon={faHome} />,
    path: '/dashboard',
    sub: []
  },
  {
    title: 'Inventory',
    icon: <FontAwesomeIcon icon={faBoltLightning} />,
    path: '/inventory',
    sub: [
      {
        title: 'Power Packs',
        icon: null,
        path: `/inventory/power-packs`
      },
      {
        title: 'Reports',
        icon: null,
        path: `/inventory/reports`
      }
    ]
  },
  {
    title: 'Arrest Alert',
    icon: <FontAwesomeIcon icon={faExclamationTriangle} />,
    path: '#',
    sub: []
  },
  {
    title: 'Reporting',
    icon: <FontAwesomeIcon icon={faChartPie} />,
    path: '#',
    sub: []
  }
]

export default navigation